import React from 'react';
import { Check } from 'lucide-react';

interface OnboardingProgressProps {
  steps: string[];
  currentStep: number;
}

const OnboardingProgress: React.FC<OnboardingProgressProps> = ({ steps, currentStep }) => {
  return (
    <div className="w-full px-4">
      <div className="max-w-4xl mx-auto">
        <div className="relative">
          {/* Progress bar background */}
          <div className="absolute top-5 left-0 right-0 h-1 bg-gray-200 rounded-full" />
          
          {/* Progress bar fill */}
          <div 
            className="absolute top-5 left-0 h-1 bg-vitl-green rounded-full transition-all duration-500"
            style={{ width: `${(currentStep / (steps.length - 1)) * 100}%` }}
          />
          
          {/* Steps */}
          <div className="relative flex justify-between">
            {steps.map((step, index) => {
              const isCompleted = index < currentStep;
              const isCurrent = index === currentStep;
              const isUpcoming = index > currentStep;
              
              return (
                <div key={index} className="flex flex-col items-center">
                  {/* Step circle */}
                  <div
                    className={`
                      w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold
                      border-2 transition-all duration-300 z-10 relative bg-white
                      ${isCompleted ? 'bg-vitl-green text-white border-vitl-green' : ''}
                      ${isCurrent ? 'bg-vitl-green text-white border-vitl-green ring-4 ring-vitl-green/20' : ''}
                      ${isUpcoming ? 'border-gray-300 text-gray-600' : ''}
                    `}
                  >
                    {isCompleted ? (
                      <Check className="w-5 h-5" />
                    ) : (
                      <span>{index + 1}</span>
                    )}
                  </div>
                  
                  {/* Step label */}
                  <div className="mt-3 text-center">
                    <div 
                      className={`
                        text-xs sm:text-sm font-medium whitespace-nowrap
                        ${isCompleted ? 'text-vitl-green' : ''}
                        ${isCurrent ? 'text-vitl-green font-semibold' : ''}
                        ${isUpcoming ? 'text-gray-500' : ''}
                      `}
                    >
                      {step}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default OnboardingProgress;